import React, { useMemo } from "react";
import { useNavigate } from "react-router";
import { useAuthContext } from "./LauncherAuthContext";
import { MehOutlined } from "@ant-design/icons";
import { Menu, MenuProps } from "antd";
import { useLoginButton } from "./login-button/useLoginButton";
import { useLocation } from "react-router-dom";
import { LoadingOverlay } from "../common/loading/component";
import { LoginButton } from "./login-button/component";
import { useTranslation } from "react-i18next";

type MenuItem = Required<MenuProps>['items'][number];

export const AccountMenu: React.FC = () => {
    const navigate = useNavigate();
    const { isUserLoggedIn, logoutUser, user } = useAuthContext();
    const location = useLocation();
    const currentPath = location.pathname;
    const { t } = useTranslation();

    const { working, setWorking, login, captureUser } = useLoginButton(() => {
        navigate(currentPath);
    }, currentPath);

    const items: MenuItem[] = useMemo(() => isUserLoggedIn() ?
        [
            {
                key: 'auth.user.name',
                label: user?.nickname,
                children: [
                    {
                        key: 'auth.my.account',
                        label: t('account.menu.my.account'),
                        onClick: () => navigate(`/profile`)
                    },
                    {
                        key: 'auth.log.out',
                        label: t('header.nav.logout'),
                        onClick: logoutUser
                    }
                ]
            },
        ] : [
            {
                key: 'auth.user.name',
                icon: <MehOutlined />,
                label: t('account.menu.not.logged.in'),
                children: [
                    {
                        key: 'auth.log.in',
                        label: <LoginButton setWorking={setWorking} login={login} captureUser={captureUser} />,
                    }
                ]
            },
        ], [isUserLoggedIn, user?.id, setWorking, login, captureUser]);

    return (
        <div>
            <LoadingOverlay working={working} />
            <Menu items={items} mode={"inline"}
                defaultSelectedKeys={['1']}
                defaultOpenKeys={['auth.user.name']} />
        </div>
    );
}
